import { useStaticQuery, graphql } from 'gatsby';

export const usePathMatch = (recordId, children) => {
  if (!recordId) {
    throw new Error(
      'usePageMatch hook requires a recordId to be passed as parameter'
    );
  }

  const data = useStaticQuery(graphql`
    query {
      allSitePage {
        pageNodes: nodes {
          path
          pageContext
        }
      }
    }
  `);

  const {
    allSitePage: { pageNodes },
  } = data;

  const pathMatch = pageNodes.find(
    ({ pageContext: { id } }) => id === recordId
  );

  if (!pathMatch) {
    alert(`No page for the provided recordId ${recordId} has been generated. Link details: ${children}`);
  }

  const { path } = pathMatch;

  return { path };
};
